import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  showSlide = false;
  showChairmanMessage = false;
  showDirectorMessage = false;
  showPrincipalMessage = false;
  showAboutFull = false;

  constructor(private router: Router) { }

  ngOnInit() {
    setInterval(() => {
      this.showSlide = !this.showSlide;
    }, 10);
  }

  navigateToAboutUs(): void {
    this.router.navigate(['/aboutUs']);
  }
}
